import type { ListingsAPIResponseNumericFacetValue } from '@noths/polaris-client-listings-api';

import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const getUpdatedOptionsForNumericFacet = (
  storeFacet: Facet,
  listingsFacetValues: ListingsAPIResponseNumericFacetValue[],
) => {
  return storeFacet.options.map((storeOption) => {
    const listingsOption = listingsFacetValues.find((value) => {
      const valueMinMax = `${value.interval.minimum || ''}-${value.interval.maximum || ''}`;

      return storeOption.value === valueMinMax;
    });

    return {
      ...storeOption,
      active: storeOption.active || false,
      count: listingsOption ? parseInt(listingsOption.count, 10) : 0,
    };
  });
};
